// extracted by mini-css-extract-plugin
export default {"message":"challenge-25_message__53ca8","divider":"challenge-25_divider__9366f","container":"challenge-25_container__fd448"};